import script from "./listPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./listPoint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__